export const ALT_ANSWER = 'DELETE'
